exports.AUTH = 'signup';
exports.AUTH_SIGNIN = 'signin';
exports.AUTH_VERIFY = 'verify';
exports.AUTH_PASSWORD_RESET = 'resetpassword';
exports.AUTH_PASSWORD_SET = 'reset'; // This is tied to a link in internal-apis - don't change this
exports.AUTH_WALLET_PASSWORD = 'walletpassword';
exports.BACKUP = 'backup';
exports.CHANNEL = 'channel';
exports.DISCOVER = 'discover';
exports.ARTISTS = 'artists';
exports.SPORTS = 'sports';
exports.BIG_HITS = 'bighits';
exports.CREATIVE_ARTS = 'arts';
exports.MOVIES = 'movies';
exports.MUSIC = 'music';
exports.COMMUNITY = 'community';
exports.DOCS_AND_FILMS = 'docs';
exports.EDUCATION = 'education';
exports.ENLIGHTENMENT = 'enlightenment';
exports.FEATURED = 'featured';
exports.FINANCE = 'finance';
exports.GAMING = 'gaming';
exports.GENERAL = 'general';
exports.LAB = 'lab';
exports.NEWS = 'news';
exports.POP_CULTURE = 'popculture';
exports.RABBIT_HOLE = 'rabbithole';
exports.SCIENCE = 'science';
exports.TECHNOLOGY = 'technology';
exports.TECH = 'tech';
exports.UNIVERSE = 'universe';
exports.WILD_WEST = 'wildwest';
exports.HOME = 'home';
exports.HELP = 'help';
exports.LIBRARY = 'library';
exports.LISTS = 'lists';
exports.PLAYLISTS = 'playlists';
exports.WATCH_HISTORY = 'watchhistory';
exports.INVITE = 'invite';
exports.FEATURED_CHANNELS = 'featured_channels';
exports.DEPRECATED__DOWNLOADED = 'downloaded';
exports.DEPRECATED__PUBLISH = 'publish';
exports.DEPRECATED__PUBLISHED = 'published';
exports.UPLOAD = 'upload';
exports.POST = 'post';
exports.UPLOADS = 'uploads';
exports.GET_CREDITS = 'getcredits';
exports.REPORT = 'report';
exports.REPORT_CONTENT = 'report_content';
exports.REWARDS = 'rewards';
exports.REWARDS_VERIFY = 'rewards/verify';
exports.REPOST_NEW = 'repost';
exports.SEND = 'send';
exports.SETTINGS = 'settings';
exports.SETTINGS_STRIPE_CARD = 'settings/card';
exports.SETTINGS_STRIPE_ACCOUNT = 'settings/tip_account';
exports.SETTINGS_NOTIFICATIONS = 'settings/notifications';
exports.SETTINGS_BLOCKED_MUTED = 'settings/block_and_mute';
exports.SETTINGS_CREATOR = 'settings/creator';
exports.SETTINGS_UPDATE_PWD = 'settings/update_password';
exports.SETTINGS_OWN_COMMENTS = 'settings/ownComments';
exports.SHOW = 'show';
exports.ACCOUNT = 'account';
exports.SEARCH = 'search';
exports.TAGS_FOLLOWING = 'tags';
exports.DEPRECATED__TAGS_FOLLOWING = 'following/tags';
exports.TAGS_FOLLOWING_MANAGE = 'tags/manage';
exports.DEPRECATED__TAGS_FOLLOWING_MANAGE = 'tags/following/manage';
exports.DEPRECATED__CHANNELS_FOLLOWING = 'following/channels';
exports.CHANNELS_FOLLOWING = 'following';
exports.DEPRECATED__CHANNELS_FOLLOWING_MANAGE = 'following/channels/manage';
exports.CHANNELS_FOLLOWING_DISCOVER = 'following/discover';
exports.CHANNELS_FOLLOWING_MANAGE = 'following/manage';
exports.WALLET = 'wallet';
exports.CHANNELS = 'channels';
exports.EMBED = 'embed';
exports.TOP = 'top';
exports.CREATOR_DASHBOARD = 'dashboard';
exports.CHECKOUT = 'checkout';
exports.CODE_2257 = '2257';
exports.PRIVACY_POLICY = 'privacypolicy';
exports.TOS = 'tos';
exports.FYP = 'fyp';
exports.YOUTUBE_TOS = 'youtubetos';
exports.BUY = 'buy';
exports.PAYMENTACCOUNT = 'paymentaccount';
exports.ARACCOUNT = 'araccount';
exports.RECEIVE = 'receive';
exports.SEND = 'send';
exports.SWAP = 'swap';
exports.CHANNEL_NEW = 'channel/new';
exports.NOTIFICATIONS = 'notifications';
exports.YOUTUBE_SYNC = 'youtube';
exports.LIVESTREAM = 'livestream';
exports.LIVESTREAM_CURRENT = 'live';
exports.LIVESTREAM_CREATE = 'livestream/create';
exports.GENERAL = 'general';
exports.LIST = 'list';
exports.PLAYLIST = 'playlist';
exports.ODYSEE_MEMBERSHIP = 'premium';
exports.CREATOR_MEMBERSHIPS = 'memberships/creator';
exports.MEMBERSHIPS_SUPPORTER = 'memberships/supporter';
exports.MEMBERSHIPS_LANDING = 'memberships';
exports.POPOUT = 'popout';
exports.LATEST = 'latest';
exports.LIVE_NOW = 'livenow';
exports.PORTALS = 'portals';
exports.PORTAL = 'portal';
exports.CAREERS = 'careers';
exports.CAREERS_IT_PROJECT_MANAGER = 'careers/it_project_manager';
exports.CAREERS_SENIOR_BACKEND_ENGINEER = 'careers/senior_backend_engineer';
exports.CAREERS_SENIOR_SYSADMIN = 'careers/senior_sysadmin';
exports.CAREERS_SOFTWARE_SECURITY_ENGINEER = 'careers/software_security_engineer';
exports.CAREERS_SENIOR_ANDROID_DEVELOPER = 'careers/senior_android_developer';
exports.CAREERS_SENIOR_IOS_DEVELOPER = 'careers/senior_ios_developer';
exports.ICONS_VIEWER = 'icons_viewer';
exports.HIDDEN_CONTENT = 'hidden';
